import { useState, useEffect } from 'react';

const useCognito = ({ cognitoScriptID, cognitoFormID }) => {
  const [scriptAdded, setScriptAdded] = useState(false);
  const [formLoaded, setFormLoaded] = useState(false);

  useEffect(() => {
    if (scriptAdded) {
      if (!formLoaded) {
        window.Cognito.load("forms", { id: `${cognitoFormID}` });
        setFormLoaded(true);
      }
    } else {
      if (window.MktoForms2) {
        setScriptAdded(true);
      } else {
        const script = document.createElement('script');
        script.defer = true;
        script.onload = () => (window?.Cognito ? setScriptAdded(true) : null);
        script.src = `https://www.cognitoforms.com/s/${cognitoScriptID}`;
        document.head.appendChild(script);
      }
    }
  }, [scriptAdded, formLoaded, cognitoScriptID, cognitoFormID]);
};

export default useCognito;